// Formatting helpers shared across pages.

export const formatDateTime = (iso) => {
  if (!iso) return '-';
  return new Date(iso).toLocaleString();
};

export const formatSoc = (soc, { hideIdleZero = false } = {}) => {
  if (soc == null || soc === '' || Number.isNaN(Number(soc))) return null;
  const n = Number(soc);
  if (hideIdleZero && n <= 0) return null;
  return `${Math.round(n)}%`;
};

const BUSY_CONNECTOR_STATUSES = [
  'Charging',
  'SuspendedEV',
  'SuspendedEVSE',
  'Occupied',
  'Finishing',
];

export const formatConnectorSoc = (connector) => {
  if (!connector) return null;
  const busy = BUSY_CONNECTOR_STATUSES.includes(connector.status);
  return formatSoc(connector.soc, { hideIdleZero: !busy });
};

export const formatDuration = (start, stop) => {
  if (!start) return '—';
  const a = new Date(start).getTime();
  const b = stop ? new Date(stop).getTime() : Date.now();
  if (!Number.isFinite(a) || !Number.isFinite(b) || b < a) return '—';
  const s = Math.round((b - a) / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h) return `${h}h ${m}m`;
  if (m) return `${m} min`;
  return `${s}s`;
};
